/** the store's platform keys as the review list names them ("sublime-text" → "Sublime Text") */
export const PLATFORM_NAMES_BY_KEY: Record<string, string> = {
  'xcode': 'Xcode',
  'zed': 'Zed',
  'sublime-text': 'Sublime Text',
  'macos-terminal': 'macOS Terminal',
  'iterm2': 'iTerm2',
  'ghostty': 'Ghostty',
  'claude-code': 'Claude Code',
  'codex': 'Codex',
  'opencode': 'OpenCode',
  'slack': 'Slack',
  'rhino': 'Rhino',
  'macos': 'macOS',
};
